<template>
  <form-field :help-text="helpText">
    <b-upload
      class="file-label"
      style="flex-shrink: 0"
      v-bind="$attrs"
      :value="value"
      :id="forId"
      :size="size"
      :accept="accept"
      @input="handleInput"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
      expanded
    >
      <span class="file-cta">
        <span class="file-label">{{ label }}</span>
      </span>

      <span class="file-name" v-if="value">
        {{ value.name }}
      </span>
    </b-upload>

    <form-validation-errors :validation-errors="validationErrors"></form-validation-errors>
  </form-field>
</template>

<script>
import FormValidationErrors from "./FormValidationErrors";
import {FormFieldMixin} from "./FormField.mixin";

export default {
  name: "FormFieldFileUpload",
  components: {FormValidationErrors},
  mixins: [FormFieldMixin],
  props: {
    value: {},
    label: {
      type: String,
      default: "Upload File"
    },
    accept: String,
    validationErrors: {
      type: [
        String,
        Array,
        Object,
        undefined
      ],
    },
    helpText: {
      type: String
    },
    size: {
      type: String,
      default: "is-small"
    },
  },
  data() {
    return {
      forId: this.inputId ? this.inputId : this.$utils.generateClientId(),
    };
  },
  methods: {
    handleInput(val) {
      this.$emit("input", val);
      this.$emit("change", val);
      this.$emit("selected", val);

      this.emitGlobalFieldChangeEvent();
    },
  }
};
</script>

<style lang="scss" scoped>

</style>
